import { render, staticRenderFns } from "./dashboard-history.vue?vue&type=template&id=2191eef6&scoped=true"
import script from "./dashboard-history.vue?vue&type=script&lang=js"
export * from "./dashboard-history.vue?vue&type=script&lang=js"
import style0 from "./dashboard-history.vue?vue&type=style&index=0&id=2191eef6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2191eef6",
  null
  
)

export default component.exports